__turbopack_context__.v({
  "cardsGrid": "BigPartnersSection-module__J8hvla__cardsGrid",
  "container": "BigPartnersSection-module__J8hvla__container",
  "heading": "BigPartnersSection-module__J8hvla__heading",
  "imageWrap": "BigPartnersSection-module__J8hvla__imageWrap",
  "insetBorder": "BigPartnersSection-module__J8hvla__insetBorder",
  "partnerActions": "BigPartnersSection-module__J8hvla__partnerActions",
  "partnerCard": "BigPartnersSection-module__J8hvla__partnerCard",
  "partnerContent": "BigPartnersSection-module__J8hvla__partnerContent",
  "partnerDescription": "BigPartnersSection-module__J8hvla__partnerDescription",
  "partnerImage": "BigPartnersSection-module__J8hvla__partnerImage",
  "partnerTitle": "BigPartnersSection-module__J8hvla__partnerTitle",
  "root": "BigPartnersSection-module__J8hvla__root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
});
